define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.splice;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/splice.js
// module id = 487
// module chunks = 0